import { VolunteerMissionAffinity } from '@wwf/sdk';
import { VolunteerMissionAffinityLabel } from '@domain/labels';

export const findVolunteerMissionAffinityLabel = (
    missionAffinityList: VolunteerMissionAffinityLabel[],
    affinityValue: VolunteerMissionAffinity
) => {
    return missionAffinityList.find(
        missionAffinity => missionAffinity.value === affinityValue
    );
};
